import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './detail.css';

const isEmpty = value =>
  value === null || value === undefined || value === '' || value === '-';

/** Label / value rows. `items` = [{ label, value }]; empty values render "-". */
const MetaList = ({ items, stacked, className }) => (
  <dl
    className={classnames(
      'dt-meta',
      { 'dt-meta--stacked': stacked },
      className
    )}
  >
    {items.map(item => (
      <div className='dt-meta__row' key={item.label}>
        <dt className='dt-meta__label'>{item.label}</dt>
        <dd className='dt-meta__value'>
          {isEmpty(item.value) ? (
            <span className='dt-meta__empty'>-</span>
          ) : (
            item.value
          )}
        </dd>
      </div>
    ))}
  </dl>
);

MetaList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node,
    })
  ).isRequired,
  stacked: PropTypes.bool,
  className: PropTypes.string,
};

export default MetaList;
